<template>
    <section id="pricing" class="section price-plan-area dark-bg overflow-hidden ptb_100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-7">
                    <!-- Section Heading -->
                    <div class="section-heading text-center">
                        <h2 class="text-white">Naš koncept razvoja</h2>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-lg-8">
                    <div class="row price-plan-wrapper">
                        <div class="col-12 col-md-6">
                            <!-- Single Price Plan -->
                            <div class="single-price-plan color-1 bg-hover hover-top dark-bg dark-shadow text-center p-5">
                                <!-- Plan Title -->
                                <div class="plan-title mb-2 mb-sm-3">
                                    <h3 class="text-white mb-2">AVM</h3>
                                    <p class="text-white-50">Koncept</p>
                                </div>
                                <!-- Plan Description -->
                                <div class="plan-description">
                                    <ul class="plan-features">
                                        <li class="text-white py-2">Razvijamo tehnologiju i sprovodimo detaljnu analitiku</li>
                                        <li class="text-white py-2">Postavljamo standarde profesije kroz ubrzanje procesa odlučivanja o kreditima</li>
                                        <li class="text-white py-2">Dajemo uvid u tržište nekretnina i rešenja za upravljanje procenom u realnom vremen</li>
                                        <li class="text-white py-2">Pružamo detaljnu analizu o stanju, kvalitetu i vrednosti nekretnina</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mt-4 mt-md-0">
                            <!-- Single Price Plan -->
                            <div class="single-price-plan color-2 bg-hover active hover-top dark-bg dark-shadow text-center p-5">
                                <!-- Plan Title -->
                                <div class="plan-title mb-2 mb-sm-3">
                                    <h3 class="text-white mb-2">ESG</h3>
                                    <p class="text-white-50">Koncept</p>
                                </div>
                                <!-- Plan Description -->
                                <div class="plan-description">
                                    <ul class="plan-features">
                                        <li class="text-white py-2">Pružamo podršku u analiziranju rizika vezanog za energetsku efikasnost imovine</li>
                                        <li class="text-white py-2">Pratimo, merimo i izveštavamo o ESG faktorima, naročito faktorima energetske efikasnosti</li>
                                        <li class="text-white py-2">Svojim klijentima pružamo potporu u vezi uticaja imovine na klimatske promene</li>
                                        <li class="text-white py-2">Savetujemo u donošenju odluka o upravljanju portfolijima i pojedinačnim segmentima imovine</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center pt-5">
                <p class="pt-4 fw-5">Niste sigurni šta vam treba? <a class="service-btn" href="tel:+381653400331"><strong>Kontaktirajte Nas</strong></a></p>
            </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>
.row {
  align-items: stretch;
}

.single-price-plan {
  height: 100%;
}
</style>
